import {connect} from 'react-redux';

const connectSubEvent = connect((state, props) => {
    let communityId = _(state).get('events.parents[' + props.eventId + ']'),
        community,
        event,
        subEvent;
    if (communityId) {
        community = state.events[communityId].event;
        subEvent = community.subevents?.find(event => event.id == props.eventId);
        event = state.events[props.eventId];
    }

    return {
        community,
        event: {
            ...community,
            ...subEvent,
            ...event
        }
    };
});

export default connectSubEvent;
